module.exports = __webpack_public_path__ + "static/images/search-1.4182b416bb1a282a1bc86124de089732.svg";